import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const LanguageKeysRoutes: Routes = [
  {
    path: "language-keys",
    loadComponent: () =>
      import("./language-keys/language-keys.component").then(
        (m) => m.LanguageKeysComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./language-keys-list/language-keys-list.component").then(
            (m) => m.LanguageKeysListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./language-keys-form/language-keys-form.component").then(
            (m) => m.LanguageKeysFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./language-keys-form/language-keys-form.component").then(
            (m) => m.LanguageKeysFormComponent,
          ),
      },
    ],
  },
];
